import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsGlobalSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-global-settings-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
